// import Modal from "@mui/material/Modal";
// import { useState, useEffect } from "react";
// import axiosClient from "../axiosClient";
// import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
// import { SketchPicker } from "react-color";
// import {
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormControl,
//   FormControlLabel,
//   FormLabel,
//   RadioGroup,
//   Radio,
//   Grid,
//   useMediaQuery,
// } from "@mui/material";

// const style = {
//   position: "absolute",
//   top: { xs: "50%", sm: "50%" },
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: "95vw", sm: "80vw", md: 800 },
//   maxHeight: { xs: "90vh", sm: "85vh", md: "600px" },
//   bgcolor: "background.paper",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: { xs: 2, sm: 3, md: 4 },
//   overflowY: "auto",
//   borderRadius: 2,
//   maxWidth: "100%",
// };

// export default function UserEditModal({ id, open, handleClose, getUsers }) {
//   const [formData, setFormData] = useState({});
//   const [role, setRole] = useState("");
//   const [gender, setGender] = useState("");
//   const [color, setColor] = useState("");
//   const [errors, setErrors] = useState({});
//   const isMobile = useMediaQuery("(max-width:600px)");

//   // Prevent background scrolling when modal is open
//   useEffect(() => {
//     if (open) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, [open]);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//     setErrors({ ...errors, [e.target.name]: "" });
//   };

//   useEffect(() => {
//     if (id) {
//       axiosClient
//         .get(`api/user/${id}/`)
//         .then((res) => {
//           const data = res?.data;
//           setFormData({
//             ...data,
//             hardcopy_consent: !!data.hardcopy_consent,
//           });
//           setGender(res?.data?.gender);
//           setRole(res?.data?.user_role);
//           setColor(res?.data?.color || "");
//           setErrors({});
//         })
//         .catch((error) => {
//           console.log(error);
//         });
//     }
//   }, [open, id]);

//   const validateForm = () => {
//     let localErrors = {};

//     if (!formData.first_name || formData.first_name.length < 2) {
//       localErrors.first_name = "First name must be at least 2 characters";
//     }

//     if (!formData.last_name || formData.last_name.length < 2) {
//       localErrors.last_name = "Last name must be at least 2 characters";
//     }

//     if (!formData.phone_number || formData.phone_number.trim() === "") {
//       localErrors.phone_number = "Phone number is required";
//     }

//     if (!formData.email) {
//       localErrors.email = "Email is required";
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       localErrors.email = "Invalid email format";
//     }

//     setErrors(localErrors);
//     return Object.keys(localErrors).length === 0;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     const payload = {
//       ...formData,
//       gender: gender,
//       color: color,
//     };

//     axiosClient
//       .patch(`api/user-edit/${id}/`, payload)
//       .then((res) => {
//         getUsers();
//         handleClose();
//       })
//       .catch((error) => {
//         console.log(error);
//         if (error.response?.data) {
//           setErrors(error.response.data);
//         }
//       });
//   };

//   // Handle modal close events
//   const handleModalClose = (event, reason) => {
//     // Prevent closing on backdrop click or Escape key press
//     if (reason === "backdropClick" || reason === "escapeKeyDown") {
//       return;
//     }
//     handleClose();
//   };

//   return (
//     <Modal
//       open={open}
//       onClose={handleModalClose}
//       aria-labelledby="modal-modal-title"
//       aria-describedby="modal-modal-description"
//       role="dialog"
//       aria-modal="true"
//       disableEscapeKeyDown
//     >
//       <Box sx={style}>
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             mb: { xs: 1, sm: 2 },
//           }}
//         >
//           <Typography
//             id="modal-modal-title"
//             sx={{ fontSize: { xs: "1.1rem", sm: "1.4rem", md: "1.5rem" }, fontWeight: "500" }}
//             variant="h4"
//             component="h2"
//           >
//             Edit User
//           </Typography>
//           <Typography
//             onClick={handleClose}
//             sx={{
//               cursor: "pointer",
//               p: { xs: 0.5, sm: 1 },
//               "& svg": { fontSize: { xs: "1.4rem", sm: "1.8rem" } },
//             }}
//             id="modal-modal-close"
//             variant="h6"
//             component="span"
//             role="button"
//             aria-label="Close modal"
//           >
//             <CloseOutlinedIcon />
//           </Typography>
//         </Box>
//         <hr
//           style={{
//             border: "none",
//             borderBottom: "1px solid #e6ebf1",
//             marginBottom: { xs: "1rem", sm: "1.5rem" },
//           }}
//         />
//         <form onSubmit={handleSubmit}>
//           <Box sx={{ mb: 2, pt: { xs: 1, sm: 2 } }}>
//             <Grid container spacing={{ xs: 1.5, sm: 2 }}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Name"
//                   variant="outlined"
//                   name="first_name"
//                   onChange={handleChange}
//                   value={formData?.first_name || ""}
//                   InputLabelProps={{
//                     shrink: true,
//                     required: true,
//                     sx: { "& .MuiFormLabel-asterisk": { color: "red" } },
//                   }}
//                   sx={{
//                     "& .MuiInputLabel-root": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                     "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                   }}
//                 />
//                 {errors?.first_name && (
//                   <Typography
//                     sx={{ textAlign: "left", mt: 0.5, fontSize: "0.8rem" }}
//                     color="error"
//                     variant="body2"
//                   >
//                     {errors.first_name}
//                   </Typography>
//                 )}
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Surname"
//                   variant="outlined"
//                   name="last_name"
//                   onChange={handleChange}
//                   value={formData?.last_name || ""}
//                   InputLabelProps={{
//                     shrink: true,
//                     required: true,
//                     sx: { "& .MuiFormLabel-asterisk": { color: "red" } },
//                   }}
//                   sx={{
//                     "& .MuiInputLabel-root": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                     "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                   }}
//                 />
//                 {errors?.last_name && (
//                   <Typography
//                     sx={{ textAlign: "left", mt: 0.5, fontSize: "0.8rem" }}
//                     color="error"
//                     variant="body2"
//                   >
//                     {errors.last_name}
//                   </Typography>
//                 )}
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   type="date"
//                   label="Date of Birth"
//                   variant="outlined"
//                   InputLabelProps={{ shrink: true }}
//                   onChange={handleChange}
//                   name="date_birth"
//                   value={formData?.date_birth || ""}
//                   sx={{
//                     "& .MuiInputLabel-root": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                     "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                   }}
//                 />
//                 {errors?.date_birth && (
//                   <Typography
//                     sx={{ textAlign: "left", mt: 0.5, fontSize: "0.8rem" }}
//                     color="error"
//                     variant="body2"
//                   >
//                     {errors.date_birth}
//                   </Typography>
//                 )}
//               </Grid>
//               <Grid item xs={12}>
//                 {/* <TextField
//                 fullWidth
//                 label="Address"
//                 variant="outlined"
//                 name="address"
//                 onChange={handleChange}
//                 value={formData?.address}
//                 InputLabelProps={{
//                   shrink: true,
//                 }}
//               />
//               <TextField
//                 fullWidth
//                 label="Postal code"
//                 variant="outlined"
//                 name="postcode"
//                 onChange={handleChange}
//                 value={formData?.postcose}
//                 InputLabelProps={{
//                   shrink: true,
//                 }}
//               />
//               <TextField
//                 fullWidth
//                 label="City"
//                 variant="outlined"
//                 name="city"
//                 onChange={handleChange}
//                 value={formData?.city}
//                 InputLabelProps={{
//                   shrink: true,
//                 }}
//               /> */}
//                 <TextField
//                   fullWidth
//                   label="Telephone"
//                   variant="outlined"
//                   name="phone_number"
//                   onChange={handleChange}
//                   value={formData?.phone_number || ""}
//                   InputLabelProps={{
//                     shrink: true,
//                     required: true,
//                     sx: { "& .MuiFormLabel-asterisk": { color: "red" } },
//                   }}
//                   sx={{
//                     "& .MuiInputLabel-root": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                     "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                   }}
//                 />
//                 {errors?.phone_number && (
//                   <Typography
//                     sx={{ textAlign: "left", mt: 0.5, fontSize: "0.8rem" }}
//                     color="error"
//                     variant="body2"
//                   >
//                     {errors.phone_number}
//                   </Typography>
//                 )}
//               </Grid>
//               <Grid item xs={12}>
//                 {/* <TextField
//                 fullWidth
//                 label="ID Number"
//                 variant="outlined"
//                 name="id_card"
//                 onChange={handleChange}
//                 value={formData?.id_card}
//                 InputLabelProps={{
//                   shrink: true,
//                 }}
//               /> */}
//                 <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                   <FormLabel
//                     component="legend"
//                     sx={{ mr: 2, fontSize: { xs: "0.9rem", sm: "0.95rem" } }}
//                   >
//                     Gender
//                   </FormLabel>
//                   <FormControl component="fieldset">
//                     <RadioGroup
//                       name="gender"
//                       value={gender}
//                       onChange={(e) => setGender(e.target.value)}
//                       sx={{ flexDirection: "row" }}
//                     >
//                       <FormControlLabel
//                         value="M"
//                         control={<Radio size="small" />}
//                         label="Male"
//                         sx={{ "& .MuiFormControlLabel-label": { fontSize: { xs: "0.9rem", sm: "0.95rem" } } }}
//                       />
//                       <FormControlLabel
//                         value="F"
//                         control={<Radio size="small" />}
//                         label="Female"
//                         sx={{ "& .MuiFormControlLabel-label": { fontSize: { xs: "0.9rem", sm: "0.95rem" } } }}
//                       />
//                     </RadioGroup>
//                   </FormControl>
//                 </Box>
//                 {errors?.gender && (
//                   <Typography
//                     sx={{ textAlign: "left", mb: 1, fontSize: "0.8rem" }}
//                     color="error"
//                     variant="body2"
//                   >
//                     {errors.gender}
//                   </Typography>
//                 )}
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Email"
//                   variant="outlined"
//                   type="email"
//                   name="email"
//                   onChange={handleChange}
//                   value={formData?.email || ""}
//                   InputLabelProps={{
//                     shrink: true,
//                     required: true,
//                     sx: { "& .MuiFormLabel-asterisk": { color: "red" } },
//                   }}
//                   sx={{
//                     "& .MuiInputLabel-root": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                     "& .MuiInputBase-input": { fontSize: { xs: "0.9rem", sm: "0.95rem" } },
//                   }}
//                 />
//                 {errors?.email && (
//                   <Typography
//                     sx={{ textAlign: "left", mt: 0.5, fontSize: "0.8rem" }}
//                     color="error"
//                     variant="body2"
//                   >
//                     {errors.email}
//                   </Typography>
//                 )}
//               </Grid>
//               {role === "STAFF" && (
//                 <Grid item xs={12}>
//                   <Typography
//                     sx={{ textAlign: "left", mt: 1.5, mb: 1, fontSize: { xs: "0.9rem", sm: "0.95rem" } }}
//                     variant="body1"
//                     gutterBottom
//                   >
//                     Pick a color for the appointment:
//                   </Typography>
//                   {isMobile ? (
//                     <input
//                       type="color"
//                       value={color}
//                       onChange={(e) => setColor(e.target.value)}
//                       style={{ width: "100%", height: "40px", borderRadius: "4px" }}
//                     />
//                   ) : (
//                     <Box sx={{ width: { sm: "200px", md: "250px" }, maxWidth: "100%" }}>
//                       <SketchPicker
//                         color={color}
//                         onChangeComplete={(newColor) => setColor(newColor.hex)}
//                         styles={{
//                           default: {
//                             picker: {
//                               width: "100%",
//                               boxShadow: "none",
//                               borderRadius: "4px",
//                               padding: "8px",
//                               fontSize: "0.9rem",
//                             },
//                           },
//                         }}
//                       />
//                     </Box>
//                   )}
//                 </Grid>
//               )}
//               <Grid item xs={12}>
//                 <Box sx={{ display: "flex", alignItems: "center", mt: 1.5, mb: 2 }}>
//                   <FormLabel
//                     component="legend"
//                     sx={{ mr: 2, fontSize: { xs: "0.9rem", sm: "0.95rem" } }}
//                   >
//                     Hardcopy Consent
//                   </FormLabel>
//                   <FormControl component="fieldset">
//                     <RadioGroup
//                       name="hardcopy_consent"
//                       value={formData?.hardcopy_consent ? "true" : "false"}
//                       onChange={(e) =>
//                         setFormData({
//                           ...formData,
//                           hardcopy_consent: e.target.value === "true",
//                         })
//                       }
//                       sx={{ flexDirection: "row" }}
//                     >
//                       <FormControlLabel
//                         value="true"
//                         control={<Radio size="small" />}
//                         label="Yes"
//                         sx={{ "& .MuiFormControlLabel-label": { fontSize: { xs: "0.9rem", sm: "0.95rem" } } }}
//                       />
//                       <FormControlLabel
//                         value="false"
//                         control={<Radio size="small" />}
//                         label="No"
//                         sx={{ "& .MuiFormControlLabel-label": { fontSize: { xs: "0.9rem", sm: "0.95rem" } } }}
//                       />
//                     </RadioGroup>
//                   </FormControl>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//           <Button
//             type="submit"
//             variant="contained"
//             color="primary"
//             fullWidth
//             sx={{
//               py: { xs: 1.2, sm: 1.5 },
//               fontSize: { xs: "0.9rem", sm: "0.95rem" },
//               borderRadius: "8px",
//             }}
//           >
//             Submit
//           </Button>
//         </form>
//       </Box>
//     </Modal>
//   );
// }

//////////////////////////////////////////////////////////////////////////


// import Modal from "@mui/material/Modal";
// import { useState, useEffect } from "react";
// import axiosClient from "../axiosClient";
// import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
// import { SketchPicker } from "react-color";
// import {
//   Typography,
//   TextField,
//   Button,
//   Box,
//   FormControl,
//   FormControlLabel,
//   FormLabel,
//   RadioGroup,
//   Radio,
//   Grid,
//   useMediaQuery,
// } from "@mui/material";

// const style = {
//   position: "absolute",
//   top: { xs: "50%", sm: "50%" },
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: "95vw", sm: "80vw", md: 800 },
//   maxHeight: { xs: "90vh", sm: "85vh", md: "600px" },
//   bgcolor: "background.paper",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: { xs: 2, sm: 3, md: 4 },
//   overflowY: "auto",
//   borderRadius: 2,
//   maxWidth: "100%",
// };

// export default function UserEditModal({ id, open, handleClose, getUsers }) {
//   const [formData, setFormData] = useState({});
//   const [gender, setGender] = useState("");
//   const [color, setColor] = useState("");
//   const [errors, setErrors] = useState({});
//   const isMobile = useMediaQuery("(max-width:600px)");

//   useEffect(() => {
//     if (open) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, [open]);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//     setErrors({ ...errors, [e.target.name]: "" });
//   };

//   useEffect(() => {
//     if (id && open) {
//       // ✅ FIX 1: Corrected path from api/user to auth/users
//       axiosClient
//         .get(`auth/users/${id}/`)
//         .then((res) => {
//           const data = res?.data;
//           setFormData({
//             first_name: data.first_name || "",
//             last_name: data.last_name || "",
//             email: data.email || "",
//             phone_number: data.phone_number || "",
//             hardcopy_consent: !!data.hardcopy_consent,
//           });
//           setGender(data.gender || "");
//           setColor(data.color || "");
//           setErrors({});
//         })
//         .catch((error) => {
//           console.log("Fetch Error:", error);
//         });
//     }
//   }, [open, id]);

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // ✅ FIX 2: Create a limited payload. 
//     // This allows you to edit only one field without affecting others or causing validation errors for missing data.
//     const payload = {
//       first_name: formData.first_name,
//       last_name: formData.last_name,
//       email: formData.email,
//       phone_number: formData.phone_number,
//       gender: gender,
//       color: color,
//       hardcopy_consent: formData.hardcopy_consent,
//     };

//     axiosClient
//       .patch(`auth/users/${id}/`, payload) // ✅ FIX 3: Corrected path
//       .then((res) => {
//         getUsers();
//         handleClose();
//       })
//       .catch((error) => {
//         console.log("Update Error:", error);
//         if (error.response?.data) {
//           setErrors(error.response.data);
//         }
//       });
//   };

//   const handleModalClose = (event, reason) => {
//     if (reason === "backdropClick" || reason === "escapeKeyDown") {
//       return;
//     }
//     handleClose();
//   };

//   return (
//     <Modal
//       open={open}
//       onClose={handleModalClose}
//       aria-labelledby="modal-modal-title"
//       aria-describedby="modal-modal-description"
//       role="dialog"
//       aria-modal="true"
//       disableEscapeKeyDown
//     >
//       <Box sx={style}>
//         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
//           <Typography id="modal-modal-title" variant="h5" component="h2" sx={{ fontWeight: "bold" }}>
//             Edit User
//           </Typography>
//           <Typography
//             onClick={handleClose}
//             sx={{ cursor: "pointer", p: 1 }}
//             role="button"
//             aria-label="Close modal"
//           >
//             <CloseOutlinedIcon />
//           </Typography>
//         </Box>
//         <hr style={{ border: "none", borderBottom: "1px solid #e6ebf1", marginBottom: "1.5rem" }} />
        
//         <form onSubmit={handleSubmit}>
//           <Box sx={{ mb: 2 }}>
//             <Grid container spacing={2}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Name"
//                   name="first_name"
//                   onChange={handleChange}
//                   value={formData?.first_name || ""}
//                   InputLabelProps={{ shrink: true }}
//                   error={!!errors.first_name}
//                   helperText={errors.first_name}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Surname"
//                   name="last_name"
//                   onChange={handleChange}
//                   value={formData?.last_name || ""}
//                   InputLabelProps={{ shrink: true }}
//                   error={!!errors.last_name}
//                   helperText={errors.last_name}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Telephone"
//                   name="phone_number"
//                   onChange={handleChange}
//                   value={formData?.phone_number || ""}
//                   InputLabelProps={{ shrink: true }}
//                   error={!!errors.phone_number}
//                   helperText={errors.phone_number}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                   <FormLabel sx={{ mr: 2 }}>Gender</FormLabel>
//                   <FormControl component="fieldset">
//                     <RadioGroup
//                       name="gender"
//                       value={gender}
//                       onChange={(e) => setGender(e.target.value)}
//                       sx={{ flexDirection: "row" }}
//                     >
//                       <FormControlLabel value="M" control={<Radio size="small" />} label="Male" />
//                       <FormControlLabel value="F" control={<Radio size="small" />} label="Female" />
//                     </RadioGroup>
//                   </FormControl>
//                 </Box>
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Email"
//                   name="email"
//                   onChange={handleChange}
//                   value={formData?.email || ""}
//                   InputLabelProps={{ shrink: true }}
//                   error={!!errors.email}
//                   helperText={errors.email}
//                 />
//               </Grid>
              
//               <Grid item xs={12}>
//                 <Box sx={{ display: "flex", alignItems: "center", mt: 1.5, mb: 2 }}>
//                   <FormLabel sx={{ mr: 2 }}>Hardcopy Consent</FormLabel>
//                   <FormControl component="fieldset">
//                     <RadioGroup
//                       name="hardcopy_consent"
//                       value={formData?.hardcopy_consent ? "true" : "false"}
//                       onChange={(e) =>
//                         setFormData({
//                           ...formData,
//                           hardcopy_consent: e.target.value === "true",
//                         })
//                       }
//                       sx={{ flexDirection: "row" }}
//                     >
//                       <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
//                       <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
//                     </RadioGroup>
//                   </FormControl>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>
//           <Button type="submit" variant="contained" color="primary" fullWidth sx={{ py: 1.5 }}>
//             Save Changes
//           </Button>
//         </form>
//       </Box>
//     </Modal>
//   );
// }



//////////////////////////////////////////////////////////////////////////

import Modal from "@mui/material/Modal";
import { useState, useEffect } from "react";
import axiosClient from "../axiosClient";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { SketchPicker } from "react-color";
import {
  Typography,
  TextField,
  Button,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Grid,
  useMediaQuery,
} from "@mui/material";

const style = {
  position: "absolute",
  top: { xs: "50%", sm: "50%" },
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95vw", sm: "80vw", md: 800 },
  maxHeight: { xs: "90vh", sm: "85vh", md: "750px" }, // Increased height to accommodate picker
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 },
  overflowY: "auto",
  borderRadius: 2,
  maxWidth: "100%",
};

export default function UserEditModal({ id, open, handleClose, getUsers }) {
  const [formData, setFormData] = useState({});
  const [gender, setGender] = useState("");
  const [color, setColor] = useState("");
  const [errors, setErrors] = useState({});
  const isMobile = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  useEffect(() => {
    if (id && open) {
      axiosClient
        .get(`auth/users/${id}/`)
        .then((res) => {
          const data = res?.data;
          setFormData({
            first_name: data.first_name || "",
            last_name: data.last_name || "",
            email: data.email || "",
            phone_number: data.phone_number || "",
            user_role: data.user_role || "", // 🛠️ Store role to check for color picker
            hardcopy_consent: !!data.hardcopy_consent,
          });
          setGender(data.gender || "");
          setColor(data.color || "#e91e63"); // 🛠️ Default color if null
          setErrors({});
        })
        .catch((error) => {
          console.log("Fetch Error:", error);
        });
    }
  }, [open, id]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone_number: formData.phone_number,
      gender: gender,
      color: color, // 🛠️ Include selected color in payload
      hardcopy_consent: formData.hardcopy_consent,
    };

    axiosClient
      .patch(`auth/users/${id}/`, payload)
      .then((res) => {
        getUsers();
        handleClose();
      })
      .catch((error) => {
        console.log("Update Error:", error);
        if (error.response?.data) {
          setErrors(error.response.data);
        }
      });
  };

  const handleModalClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      role="dialog"
      aria-modal="true"
      disableEscapeKeyDown
    >
      <Box sx={style}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography id="modal-modal-title" variant="h5" component="h2" sx={{ fontWeight: "bold" }}>
            Edit User
          </Typography>
          <Typography
            onClick={handleClose}
            sx={{ cursor: "pointer", p: 1 }}
            role="button"
            aria-label="Close modal"
          >
            <CloseOutlinedIcon />
          </Typography>
        </Box>
        <hr style={{ border: "none", borderBottom: "1px solid #e6ebf1", marginBottom: "1.5rem" }} />
        
        <form onSubmit={handleSubmit}>
          <Box sx={{ mb: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Name" name="first_name" onChange={handleChange} value={formData?.first_name || ""} InputLabelProps={{ shrink: true }} error={!!errors.first_name} helperText={errors.first_name} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Surname" name="last_name" onChange={handleChange} value={formData?.last_name || ""} InputLabelProps={{ shrink: true }} error={!!errors.last_name} helperText={errors.last_name} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Telephone" name="phone_number" onChange={handleChange} value={formData?.phone_number || ""} InputLabelProps={{ shrink: true }} error={!!errors.phone_number} helperText={errors.phone_number} />
              </Grid>
              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <FormLabel sx={{ mr: 2 }}>Gender</FormLabel>
                  <RadioGroup name="gender" value={gender} onChange={(e) => setGender(e.target.value)} sx={{ flexDirection: "row" }}>
                    <FormControlLabel value="M" control={<Radio size="small" />} label="Male" />
                    <FormControlLabel value="F" control={<Radio size="small" />} label="Female" />
                  </RadioGroup>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Email" name="email" onChange={handleChange} value={formData?.email || ""} InputLabelProps={{ shrink: true }} error={!!errors.email} helperText={errors.email} />
              </Grid>

              {/* 🛠️ COLOR PICKER SECTION: Visible only for Staff roles */}
              {(formData.user_role === "TECHNICIAN" || formData.user_role === "MAID") && (
                <Grid item xs={12}>
                  <Box sx={{ mt: 1, mb: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
                    <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: "bold" }}>
                      Calendar Task Color
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 3, alignItems: "center" }}>
                      <SketchPicker
                        color={color}
                        onChangeComplete={(c) => setColor(c.hex)}
                        disableAlpha={true}
                      />
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>Selected Color Preview:</Typography>
                        <Box sx={{ width: 60, height: 60, bgcolor: color, borderRadius: "50%", margin: "0 auto", border: "2px solid #ddd" }} />
                        <Typography variant="caption" display="block" sx={{ mt: 1 }}>{color}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              )}
              
              <Grid item xs={12}>
                <Box sx={{ display: "flex", alignItems: "center", mt: 1.5, mb: 2 }}>
                  <FormLabel sx={{ mr: 2 }}>Hardcopy Consent</FormLabel>
                  <RadioGroup name="hardcopy_consent" value={formData?.hardcopy_consent ? "true" : "false"} onChange={(e) => setFormData({ ...formData, hardcopy_consent: e.target.value === "true" })} sx={{ flexDirection: "row" }}>
                    <FormControlLabel value="true" control={<Radio size="small" />} label="Yes" />
                    <FormControlLabel value="false" control={<Radio size="small" />} label="No" />
                  </RadioGroup>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ py: 1.5 }}>
            Save Changes
          </Button>
        </form>
      </Box>
    </Modal>
  );
}